import React, { useEffect, useMemo, useState } from "react";
import { TooltipOverlay } from "app/popleads/components/TooltipOverlay";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import useDisclosure from "app/popleads/hooks/useDisclosure";
import CustomDrawer, {
    DrawerBody,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
} from "app/popleads/components/drawer/CustomDrawer";

const PrePostFilters = ({ hasAnyFilter, typeFilter, statusFilter, setTypeFilter, setStatusFilter, clearFilters }) => {
    const { isOpen, onClose, onToggle } = useDisclosure();
    const [draftType, setDraftType] = useState(typeFilter);
    const [draftStatus, setDraftStatus] = useState(statusFilter);

    useEffect(() => {
        if (isOpen) {
            setDraftType(typeFilter);
            setDraftStatus(statusFilter);
        }
    }, [isOpen, typeFilter, statusFilter]);

    const appliedCount = useMemo(() => {
        let count = 0;
        if (typeFilter !== "All") count += 1;
        if (statusFilter !== "All") count += 1;
        return count;
    }, [typeFilter, statusFilter]);

    const onApply = () => {
        setTypeFilter(draftType);
        setStatusFilter(draftStatus);
        onClose();
    };

    const onClearAll = () => {
        setDraftType("All");
        setDraftStatus("All");
        clearFilters();
    };

    return (
        <>
            <TooltipOverlay placement="bottom" tooltip="Filters">
                <ButtonWithText
                    icon="filter"
                    buttonStyle={hasAnyFilter ? "selectedOption" : "option"}
                    variant="primary"
                    onClick={onToggle}
                />
            </TooltipOverlay>

            <CustomDrawer position="right" size="md" open={isOpen} onClose={onClose}>
                <DrawerContent isLoading={false}>
                    <DrawerHeader onClose={onClose} sx={{ border: "none" }}>
                        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                            <span>Pre/Post Filters</span>
                            {appliedCount > 0 ? (
                                <span className="badge badge-primary badge-pill">{appliedCount}</span>
                            ) : null}
                        </div>
                    </DrawerHeader>
                    <DrawerBody sx={{ paddingTop: 0 }}>
                        <div className="form-group">
                            <label className="font-weight-bold">Question Type</label>
                            <select
                                className="form-control"
                                value={draftType}
                                onChange={(e) => setDraftType(e.target.value)}
                            >
                                <option value="All">All Types</option>
                                <option value="Pre">Pre</option>
                                <option value="Post">Post</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="font-weight-bold">Status</label>
                            <select
                                className="form-control"
                                value={draftStatus}
                                onChange={(e) => setDraftStatus(e.target.value)}
                            >
                                <option value="All">All Statuses</option>
                                <option value="Active">Active</option>
                                <option value="Passive">Passive</option>
                            </select>
                        </div>
                    </DrawerBody>
                    <DrawerFooter sx={{ gap: "8px", justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-light-primary" onClick={onClearAll}>
                            Clear All
                        </button>
                        <button type="button" className="btn btn-primary" onClick={onApply}>
                            Apply
                        </button>
                    </DrawerFooter>
                </DrawerContent>
            </CustomDrawer>
        </>
    );
};

export default PrePostFilters;
